import { useTranslation } from 'react-i18next';
import "./DirectMessagesHeader.css";

export default function DirectMessagesHeader() {
  const { t } = useTranslation();
  
  return (
    <div className="direct-messages-header">
      <h2 className="direct-messages-title">{t('direct.messages')}</h2>
      <span className="direct-messages-requests" id="pedidos-link">
        {t('direct.requests')} (4)
      </span>
    </div>
  );
}
